import humanizeString from 'humanize-string'
import { observer } from 'mobx-react'
import React, { Fragment, useMemo } from 'react'

import { capitalizeEachFirstLetter, mainColors, XSMedium } from '@avantstay/backoffice-core'

import { storeHolder } from '../../stores/TapeChartStore'
import * as S from './ExtendedColumns.styles'
import { ExtendedColumnConfigProps, ExtendedColumnHeaderProps } from './ExtendedColumns.types'

const _ExtendedColumnsHeader = () => {
  const rootStore = storeHolder.store
  const { activeColumns } = rootStore.extendedColumnsStore

  const columnHeaders = useMemo(() => {
    return activeColumns?.reduce<ExtendedColumnHeaderProps[]>(
      (
        accColumnHeaders: ExtendedColumnHeaderProps[],
        currentColumnHeader: ExtendedColumnConfigProps,
      ) => {
        if (currentColumnHeader.groupId) {
          const existingGroup = accColumnHeaders.find(
            columnHeader => columnHeader.groupId === currentColumnHeader.groupId,
          )

          if (existingGroup) {
            const filteredAccColumnHeaders = accColumnHeaders.filter(
              columnHeader => columnHeader.groupId !== currentColumnHeader.groupId,
            )

            return [
              ...filteredAccColumnHeaders,
              {
                ...existingGroup,
                groundHeaders: [...(existingGroup.groundHeaders ?? []), currentColumnHeader.header],
                width: existingGroup.width + currentColumnHeader.width,
              },
            ]
          }

          return [
            ...accColumnHeaders,
            {
              ...currentColumnHeader,
              groundHeaders: [currentColumnHeader.header],
              groupLabel: (
                <S.ColumnHeaderGroupTitle>
                  <XSMedium color={mainColors.neutralExtremelyDark}>
                    {capitalizeEachFirstLetter(humanizeString(currentColumnHeader.groupId))}
                  </XSMedium>
                </S.ColumnHeaderGroupTitle>
              ),
              width: currentColumnHeader.width,
            },
          ]
        }

        return [...accColumnHeaders, currentColumnHeader]
      },
      [],
    )
  }, [activeColumns])

  return activeColumns && activeColumns.length > 0 ? (
    <S.HeaderWrapper>
      {columnHeaders?.map(column => {
        return column.groupId ? (
          <S.ColumnHeaderGroupWrapper
            key={`extended-col-header-group-${column.groupId}`}
            groupWidth={column.width}
          >
            {column.groupLabel}
            <S.ColumnHeaderWrapper>
              {column.groundHeaders?.map((columnHeader, groundIndex) => (
                <Fragment key={`extendedColumnsHeader-${column.groupId}-${groundIndex}`}>
                  {columnHeader}
                </Fragment>
              ))}
            </S.ColumnHeaderWrapper>
          </S.ColumnHeaderGroupWrapper>
        ) : (
          <Fragment key={`extendedColumnsHeader-${column.columnKey}`}>{column.header}</Fragment>
        )
      })}
    </S.HeaderWrapper>
  ) : null
}

export const ExtendedColumnsHeader = observer(_ExtendedColumnsHeader)
